<template>
  <div id="getPolicyList">
    <v-header title="保单列表"></v-header>

    <!-- ******************************以下代码 勿删****************************** -->
    <!-- <div class="headercom">
      <div class="topcon">
      <span>保单列表</span>
      <el-select v-model="value" placeholder="请选择" class="topselect">
      <el-option class="topOption"
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value">
      </el-option>
      </el-select>
      </div>
    </div>-->
    <div class="listCon">
      <el-row type="flex" class="row-bg" justify="center">
        <el-col :span="14">
          <div style="margin-top: 25px;">
            <el-input placeholder="请输入内容" v-model="input5" class="input-with-select">
              <el-select v-model="select" slot="prepend">
                <el-option label="保单号" value="1"></el-option>
                <el-option label="投保人姓名" value="2"></el-option>
                <el-option label="投保人证件号" value="3"></el-option>
                <el-option label="被保人姓名" value="4"></el-option>
                <el-option label="被保人证件号" value="5"></el-option>
              </el-select>
              <el-button
                slot="append"
                size="medium"
                icon="el-icon-search"
                @click="search"
                class="topbutton"
              ></el-button>
            </el-input>
          </div>
        </el-col>
      </el-row>
      <div class="tableCon">
        <el-row type="flex" justify="center" >
          <el-popover
            class="dateChose"
            placement="bottom"
            width="350"
            visible-arrow="true"
            v-model="visible2"
          >
            <p>首次签发时间</p>
            <el-date-picker
              :editable="false"
              :clearable="false"
              v-model="value13"
              type="daterange"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              :default-time="['00:00:00', '23:59:59']"
            ></el-date-picker>
            <p>续期到期时间</p>
            <el-date-picker
              :clearable="false"
              :editable="false"
              v-model="value14"
              type="daterange"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              :default-time="['00:00:00', '23:59:59']"
            ></el-date-picker>
            <div style="text-align: center; margin:20px 0px 0px 0px;padding:0">
              <el-button size="medium" class="cancel" type="text" @click="reset2">重置</el-button>
              <el-button size="medium" class="determine" @click="sureChose">筛选</el-button>
            </div>
          </el-popover>
          <el-popover class="stateChose" placement="top" width="450" v-model="visible3">
            <el-row type="flex" justify="center">
              <el-checkbox-group v-model="checkList">
                <el-col :span="8" v-for="(item,index) in states" :key="index">
                  <el-checkbox :label="item.value">{{item.text}}</el-checkbox>
                </el-col>
              </el-checkbox-group>
            </el-row>
            <div style="text-align: center; margin:20px 0  0">
              <el-button size="mini" class="cancel" type="text" @click="reset3">重置</el-button>
              <el-button type="primary" class="determine" size="mini" @click="sureChose">筛选</el-button>
            </div>
          </el-popover>
          <el-popover class="orphanFlagChose" placement="top" width="180" v-model="visible4">
            <el-row type="flex" justify="center">
              <el-col :span="8">
                <el-radio v-model="radio" label="N">在职单</el-radio>
              </el-col>
            </el-row>
            <el-row type="flex" justify="center">
              <el-col :span="8">
                <el-radio v-model="radio" label="Y">孤儿单</el-radio>
              </el-col>
            </el-row>
            <div style="text-align: center; margin:20px 0 0">
              <el-button size="mini" class="cancel" style="width:47%" type="text" @click="reset4">重置</el-button>
              <el-button
                type="primary"
                class="determine"
                style="width:47%"
                size="mini"
                @click="sureChose"
              >筛选</el-button>
            </div>
          </el-popover>
          <el-col :span="24">
            <el-table
              class="listTableBody"

              :data="tableData.slice((currentPage-1)*pagesize,currentPage*pagesize)"
              @row-click="toDetails"
              style="width: 100%"
              :header-cell-style="cellStyle"
            >
              <el-table-column align="center" prop="chdrnum" label="保单号"></el-table-column>
              <el-table-column align="center" prop="cntType" label="产品代码" sortable></el-table-column>
              <el-table-column align="center" prop="chineseName" label="产品" width="320"></el-table-column>
              <el-table-column
                align="center"
                prop="hoissdte"
                label="首次签发日"
                :render-header="dateChose"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="statName"
                label="状态"
                :render-header="stateSearch"
              ></el-table-column>
              <el-table-column align="center" prop="cFullName" label="投保人"></el-table-column>
              <el-table-column align="center" prop="lFullName" label="被保险人"></el-table-column>
              <el-table-column align="center" prop="premium" sortable label="保费"></el-table-column>
              <el-table-column
                align="center"
                prop="oRPHAN_FLG"
                label="孤儿单标识"
                :formatter="orphanFlagShow"
                :render-header="orphanFlagChose"
              ></el-table-column>
            </el-table>
          </el-col>
        </el-row>
        <el-row type="flex" justify="center">
          <el-col :span="24" class="pages">
            <el-pagination
              @current-change="handleCurrentChange"
              :page-size="pagesize"
              layout="total, prev, pager, next, jumper"
              :total="count"
            ></el-pagination>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../../src/modules/api";
import vHeader from "@/layout/Header1.vue";
export default {
  name: "getPolicyList",
  components: { vHeader },
  data() {
    return {
      loading: true,
      radio: "",
      checkList: ["IF"],
      visible3: false,
      visible4: false,
      value13: [],
      value14: [],
      input5: "",
      select: "1",
      tableData: [],
      states: [
        { text: "到期", value: "EX" },
        { text: "有效", value: "IF" },
        { text: "延期", value: "PO" },
        { text: "保单失效", value: "LA" },
        { text: "退保", value: "SU" },
        { text: "核保", value: "UW" },
        { text: "投保书", value: "PS" },
        { text: "取消", value: "CF" },
        { text: "满期", value: "MA" },
        { text: "拒保", value: "DC" },
        { text: "付清", value: "PU" },
        { text: "终止", value: "TR" },
        { text: "撤销", value: "WD" },
        { text: "登记理赔RT", value: "RT" },
        { text: "登记理赔RD", value: "RD" },
        { text: "核准死亡理赔", value: "DH" },
        { text: "核准极限疾病理赔", value: "TC" },
        { text: "欠款失效", value: "AA" }
      ],
      CHDRCOY: "",
      BRANCH: "",
      policyNumber: "", // 保单号
      insuredPersion: "", // 投保人姓名
      insuredPersionId: "", // 投保人证件号
      applicantPersion: "", // 被保人姓名
      applicantPersionId: "", // 被保人证件号
      ORPHAN_FLG: "",
      stratDate: "", // 签发起始时间
      endDate: "", // 签发结束时间
      startDate1: "",
      endDate1: "",
      STATCODE: "IF",
      pageNumber: "1",
      count: 0,
      pagesize: 100000000,
      currentPage: 1,
      visible2: false,
      routerDTO: {
        CHDRCOY: "",
        BRANCH: "",
        CHDRNUM: "",
        AGNTNUM: "",
        VALIDFLAG: "",
        LIFE: "01",
        COVERAGE: "",
        AGNTCOY: ""
      },
      options: [
        {
          value: "1",
          label: "个险"
        },
        {
          value: "2",
          label: "团险"
        },
        {
          value: "3",
          label: "多元"
        },
        {
          value: "4",
          label: "续期"
        },
        {
          value: "5",
          label: "银保"
        }
      ],
      value: "团险",
      dialogVisible: false,
      reddot: false // header铃铛上面的红点
    };
  },
  methods: {
    // goback(){
    //   window.history.go(-1)
    // },
    toDetails(row, column) {
      console.log(this.CHDRCOY);
      this.routerDTO.CHDRCOY = this.CHDRCOY;
      this.routerDTO.BRANCH = this.BRANCH;
      this.routerDTO.CHDRNUM = row.chdrnum;
      this.routerDTO.AGNTNUM = row.agntnum;
      this.routerDTO.VALIDFLAG = row.validFlag;
      this.routerDTO.AGNTCOY = row.chdrcoy;
      sessionStorage.setItem("routerDTO", JSON.stringify(this.routerDTO));
      this.$router.push({ name: "getPolicyDetails" });
    },
    orphanFlagShow(row, column) {
      if (row.oRPHAN_FLG === "Y") {
        row.oRPHAN_FLG = "孤儿单";
      } else if (row.oRPHAN_FLG === "N") {
        row.oRPHAN_FLG = "在职单";
      }
      return row.oRPHAN_FLG;
    },
    handleCurrentChange(val) {
      let nowPage = (val - 1) * 10;
      this.pageNumber = "";
      this.pageNumber = val + "";
      console.log(this.pageNumber);
      this.getPolicyList();
    },
    stateSearch(h, { column, $index }) {
      return h("span", [
        h("span", column.label),
        h("i", {
          class: "el-icon-caret-bottom",
          on: {
            click: () => {
              if (this.visible3 === true) {
                this.STATCODE = "";
                // this.checkList = []
                // this.checkList.length = 0
                this.visible3 = false;
                this.visible4 = false;
                this.visible2 = false;
              } else {
                this.STATCODE = "";
                // this.checkList = []
                // this.checkList.length = 0
                this.visible3 = true;
                this.visible4 = false;
                this.visible2 = false;
              }
            }
          }
        })
      ]);
    },
    orphanFlagChose(h, { column, $index }) {
      return h("span", [
        h("span", column.label),
        h("i", {
          class: "el-icon-caret-bottom",
          on: {
            click: () => {
              if (this.visible4 === true) {
                this.visible3 = false;
                this.visible4 = false;
                this.visible2 = false;
              } else {
                this.visible3 = false;
                this.visible4 = true;
                this.visible2 = false;
              }
            }
          }
        })
      ]);
    },
    dateChose(h, { column, $index }) {
      return h("span", [
        h("span", column.label),
        h("i", {
          class: "el-icon-caret-bottom",
          on: {
            click: () => {
              if (this.visible2 === true) {
                this.visible3 = false;
                this.visible2 = false;
                this.visible4 = false;
              } else {
                this.visible3 = false;
                this.visible2 = true;
                this.visible4 = false;
              }
            }
          }
        })
      ]);
    },
    filterHandler() {},
    sureChose() {
      this.pageNumber = 1;
      console.log(this.value13, "选择起始时间");
      console.log(this.value14, "选择得保单结束得范围");
      console.log(this.radio, "是否为孤儿单");
      console.log(this.checkList, "状态");
      let date1 = this.value13;
      let reg = new RegExp("-", "g");
      if (date1.length !== 0) {
        this.stratDate = date1[0];
        this.stratDate = this.stratDate.replace(reg, "");
        this.endDate = date1[1];
        this.endDate = this.endDate.replace(reg, "");
      }

      let date2 = this.value14;
      if (date2.length !== 0) {
        this.startDate1 = date2[0];
        this.startDate1 = this.startDate1.replace(reg, "");
        this.endDate1 = date2[1];
        this.endDate1 = this.endDate1.replace(reg, "");
      }
      this.ORPHAN_FLG = this.radio;
      this.checkList.forEach(res => {
        if (this.STATCODE !== "") {
          this.STATCODE += "," + res;
        } else {
          this.STATCODE += res;
        }
      });
      // alert(JSON.stringify(this.checkList))
      // alert(this.STATCODE)
      console.log("STATCODE" + this.STATCODE);
      this.visible2 = false;
      this.visible3 = false;
      this.visible4 = false;
      this.getPolicyList();
    },
    getManageComInfo() {
      let option = {};
      api.getManageComInfo(option, res => {
        if (res.result.isSuccess === true) {
          this.CHDRCOY = res.data.chdrcoy;
          this.BRANCH = res.data.branch;
          this.getPolicyList();
        } else {
          this.$message("接口调用失败");
        }
      });
    },
    getPolicyList() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      let options = {
        CHDRNUM: this.policyNumber, // 保单号
        CHDRCOY: this.CHDRCOY, // 分公司号
        BRANCH: this.BRANCH, // 机构号
        COWNNAME: this.insuredPersion, // 投保人姓名
        ORPHAN_FLG: this.ORPHAN_FLG, // 孤儿单标志
        STARTDATE: this.stratDate, // 签发起始时间
        ENDDATE: this.endDate, // 签发结束时间
        STARTPTDATE: this.startDate1,
        ENDPTDATE: this.endDate1,
        ADD_CHNLCOD: "", // 渠道
        STATCODE: this.STATCODE, // 保单状态代码
        LIFENAME: this.applicantPersion, // 被保人姓名
        COWNSECUITYNO: this.insuredPersionId, // 投保人证件号
        LIFESECUITYNO: this.applicantPersionId, // 被保人证件号
        limit: "10",
        startIndex: this.pageNumber,
        orderBy: "HOISSDTE DESC" // 排序
      };
      let msg = { queryTerms: JSON.stringify(options) };
      // alert(JSON.stringify(options))
      api.getPolicyList(msg, res => {
        console.log(res, "获取的数据");
        console.log(res.result.isSuccess);
        if (res.result.isSuccess === true) {
          this.allCount = res.data.data.iTEMCOUNT;
          console.log(this.allCount);
          let response = res.data.data;
          this.tableData = [];
          response.forEach(resData => {
            resData.hoissdte =
              resData.hoissdte.slice(0, 4) +
              "-" +
              resData.hoissdte.slice(4, 6) +
              "-" +
              resData.hoissdte.slice(6, 8);
            //转换保费类型便于排序
            resData.premium = Number(resData.premium);
            this.tableData.push(resData);
          });
          // console.log(this.tableData[9].premium, '类型')
          // response.hoissdte = response.hoissdte.slice(0, 4) + '-' + response.hoissdte.slice(4, 6) + '-' + response.hoissdte.slice(6, 8)
          // this.tableData = response
          if (res.data.iTEMCOUNT) {
            this.count = Number(res.data.iTEMCOUNT);
          } else {
            this.count = 0;
          }

          loading.close();
        } else {
          loading.close();
          this.$toast("请求异常");
        }
      });
    },
    search() {
      this.pageNumber = "1";
      let that = this;
      console.log(that.select);
      if (that.select === "") {
        that.policyNumber = "";
        that.insuredPersion = "";
        that.insuredPersionId = "";
        that.applicantPersion = "";
        that.applicantPersionId = "";
        that.getPolicyList();
      } else if (that.select === "1") {
        that.policyNumber = that.input5;
        that.insuredPersion = "";
        that.insuredPersionId = "";
        that.applicantPersion = "";
        that.applicantPersionId = "";
        that.getPolicyList();
      } else if (that.select === "2") {
        that.policyNumber = "";
        that.insuredPersion = that.input5;
        that.insuredPersionId = "";
        that.applicantPersion = "";
        that.applicantPersionId = "";
        that.getPolicyList();
      } else if (that.select === "3") {
        that.policyNumber = "";
        that.insuredPersion = "";
        that.insuredPersionId = that.input5;
        that.applicantPersion = "";
        that.applicantPersionId = "";
        that.getPolicyList();
      } else if (that.select === "4") {
        that.policyNumber = "";
        that.insuredPersion = "";
        that.insuredPersionId = "";
        that.applicantPersion = that.input5;
        that.applicantPersionId = "";
        that.getPolicyList();
      } else if (that.select === "5") {
        that.policyNumber = "";
        that.insuredPersion = "";
        that.insuredPersionId = "";
        that.applicantPersion = "";
        that.applicantPersionId = that.input5;
        that.getPolicyList();
      }
    },
    reset2() {
      this.value13 = [];
      this.value14 = [];
      this.stratDate = "";
      this.endDate = "";
      this.startDate1 = "";
      this.endDate1 = "";
      this.visible2 = false;
      this.getPolicyList();
    },
    reset3() {
      this.checkList = [];
      this.STATCODE = "";
      this.visible3 = false;
      this.getPolicyList();
    },
    reset4() {
      this.ORPHAN_FLG = "";
      this.radio = "";
      this.visible4 = false;
      this.getPolicyList();
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 3 || columnIndex === 4 || columnIndex === 8) {
        // 指定坐标
        return "cursor:pointer";
      } else {
        return "";
      }
    },
    clearData() {
      this.pageNumber = "1";
      this.value13 = [];
      this.value14 = [];
      this.radio = "";
      this.stratDate = "";
      this.endDate = "";
      this.startDate1 = "";
      this.endDate1 = "";
      this.ORPHAN_FLG = "";
      this.STATCODE = "IF";
      this.checkList = ["IF"];
      this.visible2 = false;
      this.visible3 = false;
      this.visible4 = false;
      this.input5 = "";
      this.select = "1";
      this.policyNumber = "";
      this.insuredPersion = "";
      this.insuredPersionId = "";
      this.applicantPersion = "";
      this.applicantPersionId = "";
    }
  },
  activated() {
    this.clearData();
    this.getPolicyList();
    this.getManageComInfo();
  },
  mounted(){
  }
};
</script>

<style scoped>
#getPolicyList {
  /* margin-bottom:20px; */
  height: 100%;
  box-sizing: border-box;
}
.listCon {
  height: calc(100% - 70px);
  overflow: auto;
  padding-top: 60px
}
.listCon::-webkit-scrollbar{width:0px;}
.listCon::-webkit-scrollbar-thumb{background:rgba(193,193,193, .4);}

#getPolicyList >>> .el-select .el-input {
  width: 130px;
}
#getPolicyList >>> .input-with-select .el-input-group__prepend {
  background-color: #fff;
}
#getPolicyList >>> .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #c5a86e;
  border-color: #c5a86e;
}
#getPolicyList >>> .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #c5a86e;
}
#getPolicyList >>> .el-table th > .cell {
  color: #c5a86e;
}
/* #getPolicyList >>> .el-table__body-wrapper tr{ cursor:pointer;} */
.pages {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
  height: 100px;
}
.topbutton {
  color: #ffffff !important;
  background-color: #5faefa !important;
  height: 40px;
  border-radius: 0 4px 4px 0;
  border: 0;
  width: 70px;
}
.dateChose {
  position: relative;
  left: 240px;
  top: 60px;
}
.stateChose {
  position: relative;
  left: 320px;
  top: 56px;
}
.orphanFlagChose {
  position: relative;
  top: 56px;
  left: 72%;
}
.cancel {
  width: 48%;
  float: left;
  color: #000;
  border: 1px solid #c5a86e;
}
.determine {
  width: 48%;
  float: left;
  border: 1px solid #c5a86e;
  background: #c5a86e;
  color: #ffffff;
}
#getPolicyList >>> .el-radio {
  line-height: 30px;
}
/* 头部右侧下拉样式覆写 */
#getPolicyList >>> .el-select.topselect {
  position: absolute;
  right: 30px;
}
#getPolicyList >>> .el-select.topselect .el-input {
  width: 75px;
  height: 50px;
}
#getPolicyList >>> .el-select.topselect .el-input__inner {
  border: 0;
}
#getPolicyList >>> .el-select.topselect .el-input .el-select__caret {
  color: #fff;
  font-weight: bold;
}
#getPolicyList >>> .el-select.topselect .el-input__inner {
  background: transparent;
  color: #fff;
  font-weight: bold;
}
.el-select-dropdown__item.topOption.selected {
  color: #5976ba;
}
.pointer {
  cursor: pointer;
}
/* 产品列表左对齐 */
#getPolicyList >>> .el-table__row td:nth-child(3) {
  text-align: left;
}
.tableCon{
  width: 96%;
  margin:0 auto;
  /* height: calc(100% - 100px);
  overflow-y: auto; */
  margin-top: 30px;
}
/* .tableCon::-webkit-scrollbar{width:2px}
.tableCon::-webkit-scrollbar-thumb{background:rgba(193,193,193, .4);} */
/* #getPolicyList>>>.listTableBody{
    height: 100%;
    overflow: auto;
  }
#getPolicyList>>>.el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar{width:8px}
#getPolicyList>>>.el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar-thumb{background:rgba(193,193,193, .4);} */
</style>



// WEBPACK FOOTER //
// src/pages/policy/getPolicyList.vue